import { defineStore } from 'pinia'
import { LanguageChoice } from '../i18n'
import { ref, watch } from 'vue'
import { UserModel } from '../models/UserModel'
import * as Sentry from '@sentry/vue'
import { parseBool } from '../utils'

type UserState = {
  isLoggedIn: boolean
  loggedInWithSwitchTo: boolean
  id: string
  username: string
  paid_break_eligible: boolean
  /**paid break overrides can be defined (bool), or no override set (null) */
  paid_break_override: boolean | null
  language: LanguageChoice
  first_name: string
  last_name: string
  city: string
  state: string
  zip: string
  country: string
  country_id: number
}
const loginState = {
  isLoggedIn: false,
  loggedInWithSwitchTo: false,
  id: '',
  username: '',
  paid_break_eligible: false,
  paid_break_override: false,
  language: 'en_US' as LanguageChoice,
  first_name: '',
  last_name: '',
  city: '',
  state: '',
  zip: '',
  country: '',
  country_id: 1, //usa
}
const userState = ref({ ...loginState })
export const useUserStore = defineStore('user', {
  state: (): UserState => userState.value,
  getters: {
    breakOptions: (state) => {
      if (
        (state.paid_break_override === null && state.paid_break_eligible) ||
        state.paid_break_override
      ) {
        return ['break', 'paidBreak']
      } else {
        return ['break']
      }
    },
    regionSpecificActivities: (state): ((key: string) => string[]) => {
      return (actvityType) => {
        switch (state.country_id) {
          case 2:
            if (actvityType === 'other') {
              return ['minimumHourRequirement']
            }
          default:
            return []
        }
      }
    },
    distance: (state) => {
      switch (state.country_id) {
        case 2:
          return 'km'
        case 1:
          return 'miles'
        default:
          return 'miles'
      }
    },
  },
  actions: {
    setUserData(data: any) {
      this.id = data.id
      this.first_name = data.first_name
      this.last_name = data.last_name
      this.username = data.username
      this.paid_break_eligible = parseBool(data.paid_break_eligible)
      this.paid_break_override =
        data.paid_break_override === null ? null : parseBool(data.paid_break_override)
      this.city = data.city
      this.state = data.state
      this.zip = data.zip
      this.country = data.country ? data.country : 'USA'
      this.country_id = data.country_id ? Number(data.country_id) : 1
      if (data.language) {
        this.language = data.language
      }
      Sentry.setContext('user info', {
        paid_break_eligible: this.paid_break_eligible,
        paid_break_override: this.paid_break_override,
      })
      Sentry.setUser({
        id: this.id,
        username: this.username,
      })
    },
    resetStoreState() {
      skip.value = true
      this.$state = loginState
    },
  },
})

const skip = ref(false)
watch(
  userState.value,
  async () => {
    if (userState.value.id.length > 0) {
      const { writeUsersData } = UserModel()
      if (skip.value) {
        skip.value = false
      } else {
        await writeUsersData(userState.value).catch((error) => console.log(error))
      }
    }
  },
  { deep: true }
)
